
// Value object to represent a time
export class Time {
  private _hour: number = 0;
  private _minute: number = 0;

  public constructor(hour: number, minute: number) {
    this._hour = hour;
    this._minute = minute; 
  }

  public static fromString(timeString: string): Time {
    if (!this.isValidTimeString(timeString)) {
      throw Error('timeString in invalid format');
    }

    const hour = (Number.parseInt(timeString[0]) * 10) + Number.parseInt(timeString[1]);
    const minute = (Number.parseInt(timeString[3]) * 10) + Number.parseInt(timeString[4]);
    return new Time(hour, minute);
  }

  public static isValidTimeString(timeString: string): boolean {
    return /^(([01][0-9])|(2[0-3])):[0-5][0-9]$/.test(timeString);
  }

  public set hour(newVal: number) {
    this._hour = newVal;
  }

  public get hour() {
    return this._hour;
  }

  public set minute(newVal: number) {
    this._minute = newVal;
  }

  public get minute() {
    return this._minute;
  }

  public greaterThan(time: Time): boolean {
    return this._hour > time.hour ||
      (this._hour == time.hour && this._minute > time.minute);
  }

  public toString(): string {
    return `${Math.floor(this._hour / 10)}${this._hour % 10}:${Math.floor(this._minute / 10)}${this._minute % 10}`;
  }
}
